type TopbarProps = {
  statusLabel: string;
  statusTone: string;
};

export default function Topbar({ statusLabel, statusTone }: TopbarProps) {
  return (
    <header className="flex flex-wrap items-center justify-between gap-6">
      <div className="flex items-center gap-4">
        <div className="grid h-[54px] w-[54px] place-items-center rounded-[18px] bg-gradient-to-br from-accent to-[#ffc83e] text-[14px] font-bold tracking-[1px] text-bg shadow-[0_12px_24px_rgba(255,254,62,0.35)]">
          CS:GO
        </div>
        <div>
          <div className="font-display text-[26px] uppercase tracking-[1.5px]">
            CS:GO Logalyzer
          </div>
          <div className="mt-0.5 text-[13px] text-muted">CS:GO log file analyzer</div>
        </div>
      </div>
      <div className="flex items-center gap-3 max-[640px]:w-full max-[640px]:justify-between">
        <span
          className={`rounded-full border px-3.5 py-1.5 text-[12px] font-semibold uppercase tracking-[0.4px] ${statusTone}`}
        >
          {statusLabel}
        </span>
      </div>
    </header>
  );
}
